import { completeAuthentication } from './post-login'
import { datadogLogs } from '@datadog/browser-logs'
import { getSegmentId } from '../utilities/segment'

export const initializeOAuthCallback = async (): Promise<void> => {
  if (!window.location.pathname.includes('/pages/auth-callback')) {
    return
  }

  const { hasOAuthParams, processOAuthCallback, showOAuthError } = await import(
    './oauth-retry'
  )

  if (!hasOAuthParams()) {
    return
  }

  const success = await processOAuthCallback(completeAuthentication, {
    onFailure: (error) => {
      datadogLogs.logger.error('OAuth callback processing failed', {
        userId: getSegmentId(),
        url: window.location.href,
        error: error?.message || 'Unknown error',
        timestamp: new Date().toISOString(),
      })
      showOAuthError('Social sign-in failed. Please try again.')
    },
  })

  if (!success) {
    datadogLogs.logger.error('OAuth callback timed out', {
      userId: getSegmentId(),
      url: window.location.href,
      timestamp: new Date().toISOString(),
    })
    showOAuthError('Social sign-in timed out. Please try again.')
  }
}
